module.exports = __webpack_public_path__ + "img/lineworks.2099106b.png";